import { asNullableMeasure, type Measure, type Stored } from "lab-testing-units";
import { SPECIMEN_DEPTH } from "./units";

export type UscsGroup = "SP_SPSM" | "SPSC_SM_SC" | "FINES";

export interface TestIdentificationContract {
  startDate: string | null;
  endDate: string | null;
  specimenDepthTo?: Measure | null;
  visualDescription: string | null;
  comment: string | null;
  uscsGroup: UscsGroup | null;
}

export type TestIdentificationFields = TestIdentificationContract & {
  specimenReference: string | null;
  specimenDepth: Measure | null;
};

export const asTestIdentificationContract = (raw: unknown): TestIdentificationContract => {
  const stored = (raw ?? {}) as Stored<TestIdentificationContract>;
  const specimenDepthTo = asNullableMeasure(stored.specimenDepthTo, SPECIMEN_DEPTH);
  return { ...stored, ...(specimenDepthTo ? { specimenDepthTo } : {}) };
};

export const asNullableTestIdentificationContract = (raw: unknown): TestIdentificationContract | null =>
  raw == null ? null : asTestIdentificationContract(raw);
